"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgBool = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const FormRow_1 = require("../../../../3-list-item/FormRow");
const Checkbox_1 = require("../../../../2-inline-block/Checkbox");
const css_1 = require("./css");
const ArgBoolCompact_1 = require("./ArgBoolCompact");
const unwrapBool = (v) => {
    if (v && typeof v === 'object' && 'value' in v)
        return !!v.value;
    return !!v;
};
const ArgBool = (props) => {
    if (props.compact)
        return React.createElement(ArgBoolCompact_1.ArgBoolCompact, { ...props });
    const { param, value, onChange } = props;
    const v = unwrapBool(value);
    return (React.createElement("div", { className: css_1.argBlockCss },
        React.createElement(FormRow_1.FormRow, { title: param.display?.() ?? param.name ?? param.id, optional: param.optional, description: param.description, right: true },
            React.createElement("div", { style: { width: 40 } },
                React.createElement(Checkbox_1.Checkbox, { on: v, small: true, onChange: () => onChange(!v) })))));
};
exports.ArgBool = ArgBool;
